module.exports = __webpack_public_path__ + "static/media/iap-whole-sale.1f88c53d.png";